import showdown from "showdown";
import showdownHighlight from "showdown-highlight";


class MarkdownHandler {
  // showdown options documented at: https://github.com/showdownjs/showdown#valid-options
  converter = new showdown.Converter({
    tables: true, tasklists: true, smoothLivePreview: true, splitAdjacentBlockquotes: true, simpleLineBreaks: false,
    extensions: [
      showdownHighlight({ pre: true })
    ]
  });

  constructor() {
    this.converter.setFlavor('github');
  }

  doMarkdownOnLoadEvents() {
    // Namespaced, and unbound first, so calling this more than once cannot stack handlers.
    // It *is* called more than once: with Turbo Drive, `turbo:load` fires on the initial page
    // load as well as on navigations, so the two registrations at the bottom of this file both
    // run for one visit. Without the `.off`, every click on Preview fired two POSTs to
    // /markdown. The namespace keeps this from touching handlers bound elsewhere.
    $('#editor').off('click.markdown').on('click.markdown', (event) => this.openTab(event, 'editor-content'))
    $('#preview').off('click.markdown').on('click.markdown', (event) => this.previewMarkdown(event))

    // Readiness signal. The #editor/#preview tabs are in the HTML and look clickable long before
    // this pack has downloaded and run, and a click that lands early is silently swallowed — there
    // is no handler to swallow it. Marking the tab list lets anything that cares distinguish
    // "rendered" from "wired up": the browser tests wait on it instead of racing, and it is the hook
    // to use if we ever want the tabs to look disabled until they work.
    $('#editor').closest('ul').attr('data-markdown-tabs-ready', 'true')

    const toMarkdown = this.toMarkdown.bind(this)
    // test for elements with [x-convert-markdown] and set their .innerHTML
    $('[x-convert-markdown]').each(function () {
      // use innerText to prevent chars like > and & being escaped.
      this.innerHTML = toMarkdown(this.innerText)
      // prevent triggering this again (e.g., because of turbo)
      this.removeAttribute('x-convert-markdown')
    })
  }

  openTab(event, tabName) {
    const x = Array.from(document.getElementsByClassName("content-tab"));
    x.map(el => el.style.display = "none");
    const tabLinks = Array.from(document.getElementsByClassName("tab"));
    tabLinks.map(el => el.classList.remove("is-active"));
    document.getElementById(tabName).style.display = "block";
    event.currentTarget.classList.add("is-active");
  }

  // if we need this to be globally available we can do so like this:
  // window.toMarkdown = this.toMarkdown.bind(this);
  toMarkdown(text) {
    return this.converter.makeHtml(text);
  }

  previewMarkdown(event){
    const raw = document.getElementById('node_body').value;
    const data = {
      parent_id: document.getElementById('node_parent_id').value,
      body: raw
    }
    Rails.ajax({
      type: "POST",
      url: "/markdown",
      dataType: "application/json",
      data: new URLSearchParams(data).toString()
    })
    this.openTab(event, "preview-content")
  }
}

// singleton instance
const markdownHandler = new MarkdownHandler()

// Bind as soon as the DOM exists, not on `window.load`.
//
// `window.load` waits for every subresource on the page — images, and notably turbo-rails'
// lazily-imported `actioncable` chunk, which every signed-in page pulls in via
// `turbo_stream_from`. Until it fires, #preview and #editor have no click handler at all, so a
// click is silently swallowed: no preview, no error, nothing. That is what made
// MarkdownFlowTest#test_markdown fail 2 runs in 3 (measured) — and it is not test-only. A real
// user on a slow connection who clicks Preview while an image is still loading gets the same
// nothing.
//
// DOMContentLoaded is enough: these handlers only need the elements to exist. `turbo:load` stays
// for Turbo navigations, and the `.off` above makes the overlap harmless.
$(document).ready(() => markdownHandler.doMarkdownOnLoadEvents())
$(window).on("turbo:load", () => markdownHandler.doMarkdownOnLoadEvents())
